const formatDate = (date?: string) => {
  if (!date) return '-';

  return new Intl.DateTimeFormat(navigator?.language, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(new Date(date));
};

export default formatDate;
